import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';

export class RecommendationModel extends BaseModel implements Deserializable {

  // columns
  name: any;

}
